import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  fill3lmv1pckd4inv as fill,
  fill2542d4m9l93pn as fill_0,
} from '../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  fromInt2ii0rejb1w62w as fromInt,
  add2suhfggl4zvkk as add,
  multiply2k9eolhnz1bjv as multiply,
  shiftRightUnsigned1ga7wnvbv2qur as shiftRightUnsigned,
  convertToByte2t4hntblnhq2k as convertToByte,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { arrayCopytctsywo3h7gj as arrayCopy } from '../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { toByte4i43936u611k as toByte } from '../../../kotlin-kotlin-stdlib/kotlin/js/numberConversion.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function processChunk($this, input, pos) {
  var words = $this.p3u_1;
  var pos_0 = pos;
  var inductionVariable = 0;
  if (inductionVariable < 16)
    do {
      var w = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var _unary__edvuaz = pos_0;
      pos_0 = _unary__edvuaz + 1 | 0;
      // Inline function 'okio.and' call
      var tmp = (input[_unary__edvuaz] & 255) << 24;
      var _unary__edvuaz_0 = pos_0;
      pos_0 = _unary__edvuaz_0 + 1 | 0;
      // Inline function 'okio.and' call
      var tmp_0 = tmp | (input[_unary__edvuaz_0] & 255) << 16;
      var _unary__edvuaz_1 = pos_0;
      pos_0 = _unary__edvuaz_1 + 1 | 0;
      // Inline function 'okio.and' call
      var tmp_1 = tmp_0 | (input[_unary__edvuaz_1] & 255) << 8;
      var _unary__edvuaz_2 = pos_0;
      pos_0 = _unary__edvuaz_2 + 1 | 0;
      // Inline function 'okio.and' call
      words[w] = tmp_1 | input[_unary__edvuaz_2] & 255;
    }
     while (inductionVariable < 16);
  var inductionVariable_0 = 16;
  if (inductionVariable_0 < 64)
    do {
      var w_0 = inductionVariable_0;
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      var w15 = words[w_0 - 15 | 0];
      var s0 = (w15 >>> 7 | 0 | w15 << 25) ^ (w15 >>> 18 | 0 | w15 << 14) ^ (w15 >>> 3 | 0);
      var w2 = words[w_0 - 2 | 0];
      var s1 = (w2 >>> 17 | 0 | w2 << 15) ^ (w2 >>> 19 | 0 | w2 << 13) ^ (w2 >>> 10 | 0);
      var w16 = words[w_0 - 16 | 0];
      var w7 = words[w_0 - 7 | 0];
      words[w_0] = ((w16 + s0 | 0) + w7 | 0) + s1 | 0;
    }
     while (inductionVariable_0 < 64);
  hash($this, words);
}
function hash($this, words) {
  var localK = Companion_getInstance().y3u_1;
  var a = $this.q3u_1;
  var b = $this.r3u_1;
  var c = $this.s3u_1;
  var d = $this.t3u_1;
  var e = $this.u3u_1;
  var f = $this.v3u_1;
  var g = $this.w3u_1;
  var h = $this.x3u_1;
  var inductionVariable = 0;
  if (inductionVariable < 64)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var s0 = (a >>> 2 | 0 | a << 30) ^ (a >>> 13 | 0 | a << 19) ^ (a >>> 22 | 0 | a << 10);
      var s1 = (e >>> 6 | 0 | e << 26) ^ (e >>> 11 | 0 | e << 21) ^ (e >>> 25 | 0 | e << 7);
      var ch = e & f ^ ~e & g;
      var maj = a & b ^ a & c ^ b & c;
      var t1 = (((h + s1 | 0) + ch | 0) + localK[i] | 0) + words[i] | 0;
      var t2 = s0 + maj | 0;
      h = g;
      g = f;
      f = e;
      e = d + t1 | 0;
      d = c;
      c = b;
      b = a;
      a = t1 + t2 | 0;
    }
     while (inductionVariable < 64);
  $this.q3u_1 = $this.q3u_1 + a | 0;
  $this.r3u_1 = $this.r3u_1 + b | 0;
  $this.s3u_1 = $this.s3u_1 + c | 0;
  $this.t3u_1 = $this.t3u_1 + d | 0;
  $this.u3u_1 = $this.u3u_1 + e | 0;
  $this.v3u_1 = $this.v3u_1 + f | 0;
  $this.w3u_1 = $this.w3u_1 + g | 0;
  $this.x3u_1 = $this.x3u_1 + h | 0;
}
function reset($this) {
  $this.m3u_1 = 0n;
  fill($this.n3u_1, 0);
  $this.o3u_1 = 0;
  fill_0($this.p3u_1, 0);
  $this.q3u_1 = 1779033703;
  $this.r3u_1 = -1150833019;
  $this.s3u_1 = 1013904242;
  $this.t3u_1 = -1521486534;
  $this.u3u_1 = 1359893119;
  $this.v3u_1 = -1694144372;
  $this.w3u_1 = 528734635;
  $this.x3u_1 = 1541459225;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp = this;
        // Inline function 'kotlin.intArrayOf' call
        tmp.y3u_1 = new Int32Array([1116352408, 1899447441, -1245643825, -373957723, 961987163, 1508970993, -1841331548, -1424204075, -670586216, 310598401, 607225278, 1426881987, 1925078388, -2132889090, -1680079193, -1046744716, -459576895, -272742522, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, -1740746414, -1473132947, -1341970488, -1084653625, -958395405, -710438585, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, -2117940946, -1838011259, -1564481375, -1474664885, -1035236496, -949202525, -778901479, -694614492, -200395387, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, -2067236844, -1933114872, -1866530822, -1538233109, -1090935817, -965641998]);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var Sha256Class;
function Sha256() {
  if (Sha256Class === VOID) {
    class $ {
      constructor() {
        Companion_getInstance();
        this.m3u_1 = 0n;
        this.n3u_1 = new Int8Array(64);
        this.o3u_1 = 0;
        this.p3u_1 = new Int32Array(64);
        this.q3u_1 = 1779033703;
        this.r3u_1 = -1150833019;
        this.s3u_1 = 1013904242;
        this.t3u_1 = -1521486534;
        this.u3u_1 = 1359893119;
        this.v3u_1 = -1694144372;
        this.w3u_1 = 528734635;
        this.x3u_1 = 1541459225;
      }
      z3u(input, offset, byteCount) {
        var tmp = this;
        // Inline function 'kotlin.Long.plus' call
        var this_0 = this.m3u_1;
        tmp.m3u_1 = add(this_0, fromInt(byteCount));
        var pos = offset;
        var limit = pos + byteCount | 0;
        var unprocessed = this.n3u_1;
        var unprocessedLimit = this.o3u_1;
        if (unprocessedLimit > 0) {
          if ((unprocessedLimit + byteCount | 0) < 64) {
            // Inline function 'kotlin.collections.copyInto' call
            var startIndex = pos;
            // Inline function 'kotlin.js.unsafeCast' call
            // Inline function 'kotlin.js.asDynamic' call
            var tmp_0 = input;
            // Inline function 'kotlin.js.unsafeCast' call
            // Inline function 'kotlin.js.asDynamic' call
            arrayCopy(tmp_0, unprocessed, unprocessedLimit, startIndex, limit);
            this.o3u_1 = unprocessedLimit + byteCount | 0;
            return Unit_instance;
          }
          var consumeByteCount = 64 - unprocessedLimit | 0;
          var tmp6 = pos;
          // Inline function 'kotlin.collections.copyInto' call
          var endIndex = pos + consumeByteCount | 0;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp_1 = input;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          arrayCopy(tmp_1, unprocessed, unprocessedLimit, tmp6, endIndex);
          processChunk(this, unprocessed, 0);
          this.o3u_1 = 0;
          pos = pos + consumeByteCount | 0;
        }
        while (pos < limit) {
          var nextPos = pos + 64 | 0;
          if (nextPos > limit) {
            // Inline function 'kotlin.collections.copyInto' call
            var startIndex_0 = pos;
            // Inline function 'kotlin.js.unsafeCast' call
            // Inline function 'kotlin.js.asDynamic' call
            var tmp_2 = input;
            // Inline function 'kotlin.js.unsafeCast' call
            // Inline function 'kotlin.js.asDynamic' call
            arrayCopy(tmp_2, unprocessed, 0, startIndex_0, limit);
            this.o3u_1 = limit - pos | 0;
            return Unit_instance;
          }
          processChunk(this, input, pos);
          pos = nextPos;
        }
      }
      a3v() {
        var unprocessed = this.n3u_1;
        var unprocessedLimit = this.o3u_1;
        // Inline function 'kotlin.Long.times' call
        var this_0 = this.m3u_1;
        var messageLengthBits = multiply(this_0, fromInt(8));
        var _unary__edvuaz = unprocessedLimit;
        unprocessedLimit = _unary__edvuaz + 1 | 0;
        unprocessed[_unary__edvuaz] = -128;
        if (unprocessedLimit > 56) {
          fill(unprocessed, 0, unprocessedLimit, 64);
          processChunk(this, unprocessed, 0);
          fill(unprocessed, 0, 0, unprocessedLimit);
        } else {
          fill(unprocessed, 0, unprocessedLimit, 56);
        }
        unprocessed[56] = convertToByte(shiftRightUnsigned(messageLengthBits, 56));
        unprocessed[57] = convertToByte(shiftRightUnsigned(messageLengthBits, 48));
        unprocessed[58] = convertToByte(shiftRightUnsigned(messageLengthBits, 40));
        unprocessed[59] = convertToByte(shiftRightUnsigned(messageLengthBits, 32));
        unprocessed[60] = convertToByte(shiftRightUnsigned(messageLengthBits, 24));
        unprocessed[61] = convertToByte(shiftRightUnsigned(messageLengthBits, 16));
        unprocessed[62] = convertToByte(shiftRightUnsigned(messageLengthBits, 8));
        unprocessed[63] = convertToByte(messageLengthBits);
        processChunk(this, unprocessed, 0);
        var a = this.q3u_1;
        var b = this.r3u_1;
        var c = this.s3u_1;
        var d = this.t3u_1;
        var e = this.u3u_1;
        var f = this.v3u_1;
        var g = this.w3u_1;
        var h = this.x3u_1;
        reset(this);
        // Inline function 'kotlin.byteArrayOf' call
        return new Int8Array([toByte(a >> 24), toByte(a >> 16), toByte(a >> 8), toByte(a), toByte(b >> 24), toByte(b >> 16), toByte(b >> 8), toByte(b), toByte(c >> 24), toByte(c >> 16), toByte(c >> 8), toByte(c), toByte(d >> 24), toByte(d >> 16), toByte(d >> 8), toByte(d), toByte(e >> 24), toByte(e >> 16), toByte(e >> 8), toByte(e), toByte(f >> 24), toByte(f >> 16), toByte(f >> 8), toByte(f), toByte(g >> 24), toByte(g >> 16), toByte(g >> 8), toByte(g), toByte(h >> 24), toByte(h >> 16), toByte(h >> 8), toByte(h)]);
      }
    }
    initMetadataForClass($, 'Sha256', Sha256);
    Sha256Class = $;
  }
  return Sha256Class;
}
//region block: exports
export {
  Sha256 as Sha2562y5o7gt1rnojl,
};
//endregion

//# sourceMappingURL=Sha256.mjs.map
